module.exports = __webpack_public_path__ + "img/partner-break.206e15e7.webp";